<template>
  <div :class="className">
    <top-menu></top-menu>
    <h3>Reports</h3>
  </div>
</template>

<script>

import TopMenu from '~/components/TopMenu'

export default {
  data () {
    return {
    }
  },
  props: ['className'],
  components: {
    TopMenu
  }
}

</script>